import { NavLinkMultipleController } from './nav-link-multiple.controller';
import { NavLinkMultipleProps } from './nav-link-multiple.model';

export const NavLinkMultiple = (props: NavLinkMultipleProps): JSX.Element => {
  return <NavLinkMultipleController {...props} />;
};
